import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "dateFormat",
})
export class DateFormatPipe implements PipeTransform {
  transform(value: string, args?: any): any {
    if (value) {
      var d = new Date(value);
      return d.getDate() + "-" + (d.getMonth() + 1) + "-" + d.getFullYear();
    }
    return null;
  }
}
